import type { TDatadogErrorLog } from 'utils/datadog/types'

export const TERRITORY_CATEGORIES_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/components/TerritoryChipsFilter/components/CategoriesFilter/index.tsx',
  name: 'Get Territory Categories',
  message: 'Failed to fetch territory categories',
}
